"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var Observable_1 = require("rxjs/Observable");
var controls_translation_service_1 = require("../../shared/controls-translation.service");
var FieldTitlePipe = /** @class */ (function () {
    function FieldTitlePipe(translationService) {
        this.translationService = translationService;
    }
    FieldTitlePipe.prototype.transform = function (title, currentLanguageId) {
        if (!title.customText && !title.messageId) {
            return Observable_1.Observable.of('');
        }
        return title.customText && !!currentLanguageId ? this.getTitleValue(title.customText, currentLanguageId)
            : this.getMessage(title.messageId);
    };
    FieldTitlePipe.prototype.getTitleValue = function (value, langId) {
        var map = new Map();
        Object.keys(value).forEach(function (key) {
            map.set(+key, value[key]);
        });
        var langValue = new idm_crosscutting_concepts_frontend_1.MultilingualString(map).getValue(langId);
        return Observable_1.Observable.of(langValue);
    };
    FieldTitlePipe.prototype.getMessage = function (key) {
        return this.translationService && this.translationService.getMessage(key);
    };
    FieldTitlePipe = __decorate([
        core_1.Pipe({
            name: 'fieldTitle',
            pure: true
        }),
        __param(0, core_1.Optional()),
        __metadata("design:paramtypes", [controls_translation_service_1.ControlsTranslationService])
    ], FieldTitlePipe);
    return FieldTitlePipe;
}());
exports.FieldTitlePipe = FieldTitlePipe;
//# sourceMappingURL=field-title.pipe.js.map